module.exports = __webpack_public_path__ + "static/img/AboutUs_Mission_1440x985.7d5dce4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/AboutUs_Mission_1440x985.jpg
// module id = 1493
// module chunks = 5